/** @format */

import { createStore as reduxCreateStore } from 'redux'
import { createReducer } from './createReducer'

// eslint-disable-next-line no-underscore-dangle
const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__

export const createStore = (namespace, handlers, initialState) => {
  const reducer = createReducer(namespace, handlers)
  const devTools = reduxDevTools && reduxDevTools({ name: namespace })
  const store = reduxCreateStore(reducer, initialState, devTools)

  return {
    store,
    getState: store.getState.bind(store),
    subscribe: store.subscribe.bind(store),
    dispatch: (type, ...payload) => store.dispatch({ type, payload }),
  }
}
